module.exports = __webpack_public_path__ + "img/1f61a.53a952a.svg";